document.addEventListener('DOMContentLoaded', function () {
  // Placeholder for future interactive behaviors (e.g. AJAX cart, quote form validation)
  console.log('Theme loaded');
});
